import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InputText from 'Shared/components/input-text';
import styles from './text-child-component.css';


const TextChildComponent = forwardRef(({
  answer,
  label,
  disabled,
  onAnswerChange,
}, ref) => {
  const handleAnswerChanged = (event) => onAnswerChange(event.target.value);

  return (
    <div className={styles.container}>
      <InputText
        ref={ref}
        value={answer || ''}
        label={label}
        isDisabled={disabled}
        onChange={handleAnswerChanged}
        className={styles.inputContainer}
      />
    </div>
  );
});

TextChildComponent.propTypes = {
  answer: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
};

export default TextChildComponent;
